import React from 'react';
import SVG from '@newrelic/gatsby-theme-newrelic/src/components/SVG';

const KamonIcon = (props) => {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <g fillRule="nonzero" fill="none">
        <path
          d="M16.699 26.73l3.698 3.85a.738.738 0 00.507.203h9.07c.527 0 .841-.476.527-.82L22.09 19.574a.478.478 0 00-.7.01l-4.722 6.537c-.162.182-.142.425.03.608z"
          fill="#DADADA"
        />
        <path
          d="M8.926 3.3c-.73-.82-1.702-1.297-2.726-1.297-1.753 0-3.304 1.378-3.79 3.385a47.225 47.225 0 00-1.236 8.837l.993 1.358c1.773 2.442 4.854 2.553 6.759.456.284-.234.547-.497.79-.79l4.317-5.22c-.01 0-4.854-6.506-5.107-6.729z"
          fill="#199053"
        />
        <path
          d="M29.964 2.003h-7.428c-1.308 0-2.513.598-3.213 1.591l-5.31 6.435-4.317 5.22a6.47 6.47 0 01-.79.79C7 18.136 3.92 18.025 2.146 15.583l-.993-1.358c-.141 3.12.02 6.252.497 9.343v.02c.04.233.07.477.111.71.01.04.01.08.02.121a13.19 13.19 0 00.143.77c.04.203.08.396.121.598l.03.142c.051.223.092.446.142.669 0 .02.01.04.01.05.497 2.26 2.119 3.892 4.044 4.105.02 0 .03.01.05.01.132.01.254.02.386.02h.01c3.273 0 5.138-1.844 6.07-3.12L30.683 3.198c.375-.517-.03-1.196-.72-1.196z"
          fill="#34CC5B"
        />
      </g>
    </SVG>
  );
};

export default KamonIcon;
